<div class="wrapper-reponsive">
    <div class="text-center box-404">
        <p class="text-404">404</p>
        <p>Page Not Found</p>
    </div>
</div>